import { Component, inject } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AxiosError } from 'axios';
import {
  LawFirmItem,
  LawFirmService,
} from 'src/app/services/law-firm/law-firm.service';
import { PayeePopupComponent } from '../../../../shared/payee-popup/payee-popup.component';
import { PayeeFormFieldComponent } from '../../../../shared/payee-form-fields/payee-form-field/payee-form-field.component';

@Component({
  selector: 'app-set-mokk-cookie-dialog',
  templateUrl: './set-mokk-cookie-dialog.component.html',
  styleUrls: ['./set-mokk-cookie-dialog.component.scss'],
  imports: [
    PayeePopupComponent,
    PayeeFormFieldComponent,
    FormsModule,
    ReactiveFormsModule,
  ],
})
export class SetMokkCookieDialogComponent {
  private dialogRef =
    inject<MatDialogRef<SetMokkCookieDialogComponent, boolean>>(MatDialogRef);
  private lawFirmService = inject(LawFirmService);
  private snackbar = inject(MatSnackBar);
  private fb = inject(FormBuilder);

  data = inject<LawFirmItem>(MAT_DIALOG_DATA);

  readonly mokkCookie = this.fb.control('', {
    validators: [Validators.maxLength(4096)],
    nonNullable: true,
  });
  loading = false;

  readonly submit = async () => {
    if (this.mokkCookie.invalid || this.loading) {
      this.mokkCookie.markAsDirty();
      return;
    }

    const value = this.mokkCookie.getRawValue().trim();

    try {
      this.loading = true;
      const lawFirm = await this.lawFirmService.updateMokkCookie(this.data.id, {
        mokk_cookie: value || null,
      });
      this.data.has_mokk_cookie = lawFirm.has_mokk_cookie;
      this.dialogRef.close(true);
    } catch (error: AxiosError | unknown) {
      console.error('Error while updating MOKK cookie', error);
      let message = 'Ismeretlen hiba';
      if (error instanceof AxiosError && error.response?.data.message) {
        message = error.response.data.message;
      }
      this.snackbar.open(message, 'OK', { duration: 5000 });
    } finally {
      this.loading = false;
    }
  };

  readonly cancel = () => {
    this.dialogRef.close(false);
  };
}
